import { Box } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import EmptyState from './EmptyState';
import useNoResultsEmptyStateStyles from './noResultsEmptyState.styles';

interface NoResultsEmptyStateProps {
  testId?: string;
}

const NoResultsEmptyState = ({ testId }: NoResultsEmptyStateProps) => {
  const { classes } = useNoResultsEmptyStateStyles();

  return (
    <Box className={classes.content}>
      <EmptyState
        testId={testId}
        title={{ text: LangEnum.GLOBAL_LIST_NO_RESULTS_TITLE }}
        description={{ text: LangEnum.GLOBAL_LIST_NO_RESULTS_DESCRIPTION }}
      />
    </Box>
  );
};

export default NoResultsEmptyState;
